import React, { FC, useRef } from 'react';
import ColorWrapper from '@styles/colors';
import { isPhone, machineStatusColorName } from '@helpers';
import { scale as initialScale } from '@components/frame';
import { Text, View } from 'react-native';
import { MachineNameAndStatusProps } from '@v2/pages/machines/common/types/props';
import TouchableElement from '@components/common/touchableElement';
import { font as initialFont } from '@styles/fonts';
import { useNavigation } from '@react-navigation/native';
import i18n from 'i18n-js';
import Svg from '@styles/icons/svg';
import { useHandleNavigationMachinesHeader } from '@v2/pages/machines/hooks/useHandleNavigationMachineHeader';
import { connect } from 'react-redux';
import { setIsMachinesSelectModalOpen } from '@reducers/machinesV2';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';
import { MachineStatusBulletDisplayVariant } from './types';

const MachineNameAndStatus: FC<MachineNameAndStatusProps> = ({
  selectedItem,
  C,
  setIsMachinesSelectModalOpen,
  withoutInteractions,
  statusDisplayVariant = MachineStatusBulletDisplayVariant.NOT_VISIBLE,
  scale = initialScale,
  font = initialFont,
}) => {
  const navigation = useNavigation();
  const { isNowSubScreen } = useHandleNavigationMachinesHeader();
  const { isAllSelected } = useHandleParams();

  const secretScreen = useRef<number>(0);

  const isPhoneMachineList = isAllSelected && isPhone;

  const goToSecret = () => {
    if (withoutInteractions) return;

    if (secretScreen.current === 4) {
      secretScreen.current = 0;
      navigation.navigate('MachineDetailsSecret', { id: selectedItem.machineId });
    } else {
      secretScreen.current += 1;
    }
  };

  const shouldRenderMachineStatusBullet = statusDisplayVariant !== MachineStatusBulletDisplayVariant.HIDDEN;
  const shouldMachineStatusBulletBeVisible = statusDisplayVariant === MachineStatusBulletDisplayVariant.VISIBLE;

  return (
    <View style={{ paddingRight: isPhone ? scale(75) : 0, paddingLeft: scale(isPhone ? 9 : 0), justifyContent: 'center' }}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {shouldRenderMachineStatusBullet && (
          <View
            style={{
              backgroundColor: selectedItem?.hasNoDataInPeriod
                ? C('Label/Light/Quaternary')
                : selectedItem?.machineStatus?.status
                ? C(machineStatusColorName[selectedItem.machineStatus.status])
                : 'transparent',
              height: scale(12.5),
              width: scale(12.5),
              borderRadius: scale(12.5 / 2),
              opacity: shouldMachineStatusBulletBeVisible
                ? 1
                : !isNowSubScreen || selectedItem?.isProcessingPI || selectedItem?.machineStatisticsOnly
                ? 0
                : 1,
            }}
          />
        )}
        <TouchableElement onPress={() => goToSecret()}>
          {() => (
            <View>
              <Text
                style={[
                  {
                    color: C('Label / Light / Primary'),
                    marginLeft: scale(isPhoneMachineList ? 0 : 7),
                  },
                  font[isPhoneMachineList ? 'Large Title' : 'Title 2'],
                ]}
                numberOfLines={1}
                ellipsizeMode={'middle'}
              >
                {isPhoneMachineList ? i18n.t('Machines') : isAllSelected ? i18n.t('All Machines') : selectedItem?.shortName}
              </Text>
            </View>
          )}
        </TouchableElement>
        {isPhone && !isPhoneMachineList && !withoutInteractions && (
          <TouchableElement onPress={() => setIsMachinesSelectModalOpen(true)}>
            {({ boxStyle }) => (
              <View
                style={[
                  boxStyle,
                  {
                    marginLeft: scale(10),
                    backgroundColor: C('Button/Light/Secondary'),
                    borderRadius: scale(8),
                    width: scale(17),
                    height: scale(17),
                    justifyContent: 'center',
                    alignItems: 'center',
                  },
                ]}
              >
                <Svg icon="chevronBottomLight" height={10} width={10} color={'Button/Light/Primary'} />
              </View>
            )}
          </TouchableElement>
        )}
      </View>
    </View>
  );
};

export default connect(({}) => ({}), { setIsMachinesSelectModalOpen })(ColorWrapper(MachineNameAndStatus));
